import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  updateWorkerPlanAction,
  createWorkerPlanAction,
} from "../../../../../redux/actions/workerPlanAction";
import LoadingBtn from "../../../../Loading/components/LoadingBtn/LoadingBtn";

const SubmitBtn = ({ formik, modalData, workDays, leadDays, funcType }) => {
  const dispatch = useDispatch();
  const { workerPlanModalLoading: modalLoading } = useSelector(
    (state) => state.workerPlanModal
  );
  const [isDisabled, setIsDisabled] = useState(() => {
    return true;
  });
  const dataCreate = () => {
    const payload = {
      worker: formik.values.worker,
      workDays,
      leadDays,
    };

    if (modalData?._id) {
      dispatch(updateWorkerPlanAction(modalData._id, payload));
    } else {
      dispatch(createWorkerPlanAction(payload));
    }
  };

  useEffect(() => {
    const invalidSchedule = (schedule) =>
      !Array.isArray(schedule) ||
      schedule.length === 0 ||
      schedule.some((item) => !item.day || !item.startTime || !item.endTime);

    setIsDisabled(
      !formik.values.worker ||
        invalidSchedule(workDays) ||
        invalidSchedule(leadDays)
    );
  }, [formik.values.worker, workDays, leadDays]);

  return (
    <div>
      <div className="create-update-modal-btn">
        <button disabled={isDisabled || modalLoading} onClick={dataCreate}>
          {modalLoading ? (
            <LoadingBtn />
          ) : funcType === "update" ? (
            "Yenilə"
          ) : (
            "Yarat"
          )}
        </button>
      </div>
    </div>
  );
};

export default SubmitBtn;
